import "../css/index.css";

document.addEventListener("DOMContentLoaded", () => {
    const postLinks = document.querySelectorAll("article a");
    for (let i = 0; i < postLinks.length; i++) {
        if (postLinks[i].hostname != window.location.hostname) {
            postLinks[i].target = "_blank";
            postLinks[i].rel = "noopener";
        }
    }
});
